import { Alert } from "react-bootstrap";
import { ToastInfo } from "../../shared/models/ToastInfo";
import { ToastInfoType } from "../../shared/Enums";

interface MessageDataProps {
  messages: ToastInfo;
  onDismiss?: () => void;
}

export default function MessageData({ messages, onDismiss }: MessageDataProps) {
  const getVariant = (type: ToastInfoType): string => {
    switch (type) {
      case ToastInfoType.Error:
        return "danger";
      case ToastInfoType.Warning:
        return "warning";
      case ToastInfoType.Info:
        return "info";
      case ToastInfoType.Success:
        return "success";
      default:
        return "info";
    }
  };

  const getIcon = (type: ToastInfoType): string => {
    switch (type) {
      case ToastInfoType.Error:
        return "fas fa-exclamation-circle";
      case ToastInfoType.Warning:
        return "fas fa-exclamation-triangle";
      case ToastInfoType.Info:
        return "fas fa-info-circle";
      case ToastInfoType.Success:
        return "fas fa-check-circle";
      default:
        return "fas fa-info-circle";
    }
  };

  if (!messages.isShow) {
    return null;
  }

  return (
    <div className="message-data-container">
      <Alert variant={getVariant(messages.type)} dismissible={!!onDismiss} onClose={onDismiss}>
        <div className="d-flex align-items-start">
          <i className={`${getIcon(messages.type)} me-2 mt-1`}></i>
          <div className="flex-grow-1">
            <span>{messages.text}</span>
          </div>
        </div>
      </Alert>
    </div>
  );
}
